import React from "react";
import { motion } from "framer-motion";
import { Play, ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/ui";

const IG = "https://instagram.com/hi._.manganese";

const REELS = [
  {
    title: "High-Energy Makeup Transition Reel",
    tag: "Transition Edit",
    views: "5.9K views",
    img: "/reel-a.jpg",
    href: "https://www.instagram.com/reel/Dac_eAazQ6u/",
    span: "sm:col-span-4",
  },
  {
    title: "12-Hour Shift-Proof Beauty GRWM",
    tag: "Shift-Ready GRWM",
    views: "4.2K views",
    img: "/reel-b.jpg",
    href: "https://www.instagram.com/reel/DMscvOcTVJI/",
    span: "sm:col-span-4",
  },
  {
    title: "Nail & Outfit Wear-Test",
    tag: "Wear-Test",
    views: "25.7K views",
    img: "/reel-c.jpg",
    href: "https://www.instagram.com/reel/DXVzDN7kzAo/",
    span: "sm:col-span-4",
  },
];

export const Portfolio = () => {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="px-4 py-20 sm:px-6 sm:py-28">
      <div className="mx-auto max-w-6xl">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mb-12 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end"
        >
          <div>
            <span className="font-body text-sm font-bold uppercase tracking-widest text-clay-violet">
              Featured work
            </span>
            <h2 className="mt-3 font-display text-4xl font-black tracking-tighter text-clay-ink sm:text-6xl">
              Reels that convert.
            </h2>
          </div>
          <a
            href={IG}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="portfolio-viewall-btn"
            className="flex items-center gap-2 rounded-full border-[3px] border-clay-ink bg-white px-5 py-2.5 font-display text-sm font-bold text-clay-ink shadow-brutal-sm transition-transform hover:translate-x-[2px] hover:translate-y-[2px]"
          >
            View all on Instagram
            <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
          </a>
        </motion.div>

        <div className="grid grid-cols-1 gap-7 sm:grid-cols-12">
          {REELS.map((r, i) => (
            <motion.a
              key={r.title}
              href={r.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`reel-card-${i}`}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className={`group relative overflow-hidden rounded-[2.25rem] border-[3px] border-clay-ink shadow-clay ${r.span}`}
            >
              <img
                src={r.img}
                alt={r.title}
                className="h-[360px] w-full object-cover object-[center_30%] transition-transform duration-700 group-hover:scale-105 sm:h-[460px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-clay-ink/85 via-clay-ink/10 to-transparent" />

              <span className="absolute right-5 top-5 flex items-center gap-1.5 rounded-full border-[3px] border-clay-ink bg-clay-lime px-3 py-1 font-body text-xs font-bold uppercase tracking-wider text-clay-ink">
                {r.tag}
              </span>

              <div className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-[3px] border-clay-ink bg-clay-violet shadow-brutal-sm transition-transform duration-300 group-hover:scale-110">
                <Play className="ml-0.5 h-6 w-6 text-white" fill="white" strokeWidth={1.5} />
              </div>

              <div className="absolute inset-x-0 bottom-0 p-6">
                <p className="font-body text-xs font-bold uppercase tracking-wider text-clay-lime">
                  {r.views}
                </p>
                <h3 className="mt-1 font-display text-2xl font-black leading-tight tracking-tight text-white">
                  {r.title}
                </h3>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
